module.exports = __webpack_public_path__ + "static/media/logo-whosgood@3x.c7dff473.png";